import React, { useRef } from "react";
import TYPE from "../../../constant/TYPE";
import { getMathJaxNode } from "../mathjax/MathJax";

const NumberTable = ( props ) => {

  const prevData = useRef( [] );
  const mathjaxRenderCount = useRef( 0 );

  const startKeyword = `\\begin{${ TYPE.LATEX_CODE.NUMBER_TABLE }}`;
  const endKeyword = `\\end{${ TYPE.LATEX_CODE.NUMBER_TABLE }}`;
  const data = props.children.slice( props.children.indexOf( startKeyword ) + startKeyword.length, props.children.indexOf( endKeyword ) ).split( '&' ).map( v => v.trim() );
  const changedDataCount = data.filter( ( v, i ) => prevData.current[ i ] !== v ).length;

  const MathJaxNode = getMathJaxNode( props.type );

  const mapColumns = ( v, i ) => <li key={ i }><span className="numberline-num"><MathJaxNode onRender={ renderMathJax }>{ v }</MathJaxNode></span></li>;

  const renderMathJax = () => {
    mathjaxRenderCount.current++;
    if ( changedDataCount === mathjaxRenderCount.current ) {
      prevData.current = data;
      mathjaxRenderCount.current = 0;
      props.onRender();
    }
  };

  const COLUMNS = data.map( mapColumns );

  return <ul className="numberline-list">{ COLUMNS }</ul>;

};

export default NumberTable;
